// 衛教 hash → i18n area key（標題在元件以 useTranslation('edu') 組合，支援多語）
export const infoHashToAreaKey: Record<string, string> = {
    '#0': 'baby',
    '#1': 'toddler',
    '#3': 'child',
    '#6': 'school',
    '#n': 'newParent',
    '#e': 'earlyTherapy',
};

export const getInfoAreaKey = (hash: string): string => infoHashToAreaKey[hash] || '';
